module.exports = __webpack_public_path__ + "static/media/8900_LivingRoom.f8f61670.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/8900_LivingRoom.jpg
// module id = 103
// module chunks = 0